import { fmtNum } from "../lib/format";
import TrendBadge from "./TrendBadge";
import Sparkline from "./Sparkline";
import TrendButton from "./TrendButton";
import { useModuleContext, inferUnit, extractNumeric } from "../lib/moduleCtx";

export default function Kpi({
  label, value, sub, alert, onClick, testid, icon, trend, sparkline, sparkColor,
  // Optional overrides for the Trend Analyzer
  widgetId, module, unit, currentNumeric,
  // Set false to hide the trend button on this specific widget
  showTrend = true,
}) {
  const sparkTone = sparkColor || (alert ? "var(--cv-crimson)" : "var(--cv-slate)");
  const autoModule = useModuleContext();
  const resolvedModule = module || autoModule;
  const resolvedUnit = unit || inferUnit(value);
  const resolvedWidgetId = widgetId || testid; // auto-derive from testid
  const num = typeof currentNumeric === "number" ? currentNumeric : extractNumeric(value);

  return (
    <div
      className={`cv-kpi ${alert ? "alert" : ""} relative`}
      style={{ width: "100%" }}
      data-testid={testid}
    >
      <button
        type="button"
        data-testid={testid ? `${testid}-body` : undefined}
        onClick={onClick}
        className="text-left w-full"
        style={{ background: "transparent", padding: 0, border: 0, cursor: onClick ? "pointer" : "default" }}
      >
        <div className="flex justify-between items-start gap-2">
          <div className="cv-kpi-label">{label}</div>
          {trend ? <TrendBadge trend={trend} size="sm" testid={`${testid}-trend`} /> : icon}
        </div>
        <div className="cv-kpi-value">{typeof value === "number" ? fmtNum(value) : value}</div>
        {sparkline && sparkline.length > 0 && (
          <div className="mt-1">
            <Sparkline data={sparkline} color={sparkTone} height={32} testid={`${testid}-spark`} />
          </div>
        )}
        <div className="cv-kpi-sub">{sub}</div>
      </button>
      {showTrend && resolvedWidgetId && (
        <div className="mt-2 flex justify-end">
          <TrendButton
            widgetId={resolvedWidgetId}
            label={label}
            module={resolvedModule}
            unit={resolvedUnit}
            current={num}
            testid={testid ? `${testid}-view-trend` : undefined}
          />
        </div>
      )}
    </div>
  );
}
